import { createTheme } from '@mui/material/styles';
import defaultTheme from './default';
import overrides from './overrides';
import { FONT_FAMILY } from './fonts';

function getDefaultTheme () {
  return createTheme({
    ...defaultTheme,
    ...overrides,
    typography: {
      ...(defaultTheme.typography || {}),
      ...(overrides.typography || {}),
      fontFamily: FONT_FAMILY,
      fontFamilyRegular: FONT_FAMILY,
      fontFamilyBold: FONT_FAMILY,
      h1: { fontSize: '20px', lineHeight: '100%', fontWeight: '500' },
      h2: { fontSize: '18px', lineHeight: '100%', fontWeight: '500' },
      h3: { fontSize: '14px', lineHeight: '100%', fontWeight: '300' },
      h4: { fontSize: '12px', lineHeight: '100%', fontWeight: '500' },
      h5: { fontSize: '12px', lineHeight: '100%', fontWeight: '400' },
      body1: { fontSize: '14px', lineHeight: '21px', fontWeight: '300' },
      body2: { fontSize: '12px', lineHeight: '21px', fontWeight: '300' },
      button: { fontSize: '12px', fontWeight: '500' },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { fontFamily: FONT_FAMILY },
        },
      },
      MuiButtonBase: {
        styleOverrides: {
          root: { fontSize: '12px' },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: { fontFamily: FONT_FAMILY },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          shrink: {
            backgroundColor: '#FFFFFF',
            padding: '2px',
            borderRadius: '2px',
          },
        },
      },
    },
  });
}

const theme = {
    default: getDefaultTheme(),
};

export default theme;
